import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
import { Home } from './pages/Home';
import { ServiceDetail } from './pages/ServiceDetail';
import { Popup } from './components/Popup';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-[#FF9500] selection:text-black" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/services/:slug" element={<ServiceDetail data-id="element-8" />} data-id="element-7" />
            <Route path="*" element={<Home data-id="element-10" />} data-id="element-9" />
          </Routes>
        </main>
        <Footer data-id="element-11" />
        <FloatingActions data-id="element-12" />
        <Popup data-id="element-13" />
      </div>
    </BrowserRouter>;
}